var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 14.6666L11.6667 11.6666M13.3333 7.33331C13.3333 10.647 10.647 13.3333 7.33333 13.3333C4.01963 13.3333 1.33333 10.647 1.33333 7.33331C1.33333 4.0196 4.01963 1.33331 7.33333 1.33331C10.647 1.33331 13.3333 4.0196 13.3333 7.33331Z",
    stroke: "currentColor",
    strokeWidth: 1.77778,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.752dabce79a3bb256b36f7f0c0d3af53.svg";
export { ForwardRef as ReactComponent };